/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Compliance_Bfsg_SubInputs */

const en_landing_compliance_bfsg_sub = /** @type {(inputs: Landing_Compliance_Bfsg_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accessibility features`)
};

const de_landing_compliance_bfsg_sub = /** @type {(inputs: Landing_Compliance_Bfsg_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktionen zur Barrierefreiheit`)
};

const fr_landing_compliance_bfsg_sub = /** @type {(inputs: Landing_Compliance_Bfsg_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonctions d’accessibilité`)
};

const es_landing_compliance_bfsg_sub = /** @type {(inputs: Landing_Compliance_Bfsg_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funciones de accesibilidad`)
};

const it_landing_compliance_bfsg_sub = /** @type {(inputs: Landing_Compliance_Bfsg_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funzionalità di accessibilità`)
};

const nl_landing_compliance_bfsg_sub = /** @type {(inputs: Landing_Compliance_Bfsg_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toegankelijkheidsfuncties`)
};

const pl_landing_compliance_bfsg_sub = /** @type {(inputs: Landing_Compliance_Bfsg_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funkcje dostępności`)
};

const fi_landing_compliance_bfsg_sub = /** @type {(inputs: Landing_Compliance_Bfsg_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saavutettavuusominaisuudet`)
};

const da_landing_compliance_bfsg_sub = /** @type {(inputs: Landing_Compliance_Bfsg_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilgængelighedsfunktioner`)
};

const sv_landing_compliance_bfsg_sub = /** @type {(inputs: Landing_Compliance_Bfsg_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tillgänglighetsfunktioner`)
};

/**
* | output |
* | --- |
* | "Accessibility features" |
*
* @param {Landing_Compliance_Bfsg_SubInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_compliance_bfsg_sub = /** @type {((inputs?: Landing_Compliance_Bfsg_SubInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Compliance_Bfsg_SubInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_compliance_bfsg_sub(inputs)
	if (locale === "fr") return fr_landing_compliance_bfsg_sub(inputs)
	if (locale === "es") return es_landing_compliance_bfsg_sub(inputs)
	if (locale === "it") return it_landing_compliance_bfsg_sub(inputs)
	if (locale === "nl") return nl_landing_compliance_bfsg_sub(inputs)
	if (locale === "pl") return pl_landing_compliance_bfsg_sub(inputs)
	if (locale === "fi") return fi_landing_compliance_bfsg_sub(inputs)
	if (locale === "da") return da_landing_compliance_bfsg_sub(inputs)
	if (locale === "sv") return sv_landing_compliance_bfsg_sub(inputs)
	return en_landing_compliance_bfsg_sub(inputs)
});